import { useEffect, useState } from 'react';
import { notificationsApi } from '../api';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
}

export default function usePushNotification() {
  const [permission, setPermission] = useState(Notification?.permission || 'default');

  useEffect(() => {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      registerPush();
    }
  }, []);

  const registerPush = async () => {
    try {
      const reg = await navigator.serviceWorker.ready;
      const existing = await reg.pushManager.getSubscription();
      if (existing) {
        await saveSubscription(existing);
        return;
      }
      if (Notification.permission === 'granted') {
        await subscribe(reg);
      }
    } catch (err) {
      console.error('Push registration error:', err);
    }
  };

  const requestPermission = async () => {
    try {
      const result = await Notification.requestPermission();
      setPermission(result);
      if (result === 'granted') {
        const reg = await navigator.serviceWorker.ready;
        await subscribe(reg);
      }
    } catch (err) {
      console.error('Permission error:', err);
    }
  };

  const subscribe = async (reg) => {
    const subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
    await saveSubscription(subscription);
  };

  const saveSubscription = async (subscription) => {
    try {
      await notificationsApi.subscribePush(subscription.toJSON());
    } catch (err) {
      console.error('Save subscription error:', err);
    }
  };

  return { permission, requestPermission };
}